import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from '../context/authContext';

/** Throws outside <AuthProvider> — a silent null here would fail much later. */
export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (value === null) {
    throw new Error('useAuth must be used inside <AuthProvider>.');
  }
  return value;
}
